module.exports = __webpack_public_path__ + "support-tools-ic.svg?9321fb6264ae4c269597f32de630ebc5";